import React, { useState } from 'react';
import { BsShieldCheck, BsGrid, BsTrophy, BsPeople } from 'react-icons/bs';
import { LeaguesList } from './LeaguesList';
import { useAuth } from '../../hooks/authHook';

export const LeaguesPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('list');
  const { isAuthenticated } = useAuth();

  const tabs = [
    {
      id: 'list',
      name: 'Ligas',
      icon: BsShieldCheck,
      description: 'Ver todas las ligas disponibles',
    },
    {
      id: 'calendar',
      name: 'Calendario',
      icon: BsGrid,
      description: 'Vista de calendario de ligas',
    },
    {
      id: 'statistics',
      name: 'Estadísticas',
      icon: BsTrophy,
      description: 'Estadísticas globales de ligas',
    },
    ...(isAuthenticated ? [{
      id: 'myLeagues',
      name: 'Mis Ligas',
      icon: BsPeople,
      description: 'Ligas en las que participo',
    }] : []),
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'list':
        return <LeaguesList />;
      case 'calendar':
        return (
          <div className="text-center py-12">
            <BsGrid className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              Vista de calendario próximamente
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              La vista de calendario de ligas estará disponible pronto.
            </p>
          </div>
        );
      case 'statistics':
        return (
          <div className="text-center py-12">
            <BsTrophy className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              Estadísticas próximamente
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Las estadísticas de ligas estarán disponibles pronto.
            </p>
          </div>
        );
      case 'myLeagues':
        return (
          <div className="text-center py-12">
            <BsPeople className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              Mis ligas próximamente
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              La sección de mis ligas estará disponible pronto.
            </p>
          </div>
        );
      default:
        return <LeaguesList />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Tabs Navigation */}
        <div className="bg-white shadow rounded-lg mb-8">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6" aria-label="Tabs">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`${
                      isActive
                        ? 'border-indigo-500 text-indigo-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors duration-200`}
                    title={tab.description}
                  >
                    <Icon className="h-5 w-5" />
                    <span>{tab.name}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white shadow rounded-lg p-6">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};
